module.exports = __webpack_public_path__ + "static/media/JohnL.166151e7.jpeg";